










































































import dateFns from 'date-fns';
import { sortBy } from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { isFixturePlayed } from '@/services/FixtureService';
import { SCORE_MODAL_DATE_TIME_FORMAT } from '@/constants/utils';
import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';
import { TeamInterface, FixtureInterface, ActivityInterface } from '@/interfaces/interfaces';

@Component({
  components: { TeamLogo }
})
export default class TableTennisScoreModal extends Vue {
  @Prop() public triggerShowModal!: any;

  @Prop({ default: false }) private showModal!: boolean;
  @Prop({ default: null }) private fixture!: FixtureInterface;

  public close() {
    this.triggerShowModal(false);
  }

  public doNothing(e: any) {
    e.stopPropagation();
  }

  public isTeamWinner(team: TeamInterface) {
    const winnerTeam =
      this.fixture && this.fixture.homeTeamScore > this.fixture.awayTeamScore
        ? this.fixture && this.fixture.homeTeam
        : this.fixture && this.fixture.awayTeam;

    return winnerTeam && team.id === winnerTeam.id;
  }

  public isSetWinner(activity: ActivityInterface, team: string) {
    if (team.toLowerCase() === 'home' && activity.homeTeamPoints > activity.awayTeamPoints) {
      return true;
    }

    if (team.toLowerCase() === 'away' && activity.awayTeamPoints > activity.homeTeamPoints) {
      return true;
    }

    return false;
  }

  public getWinnerClassObject(team: TeamInterface) {
    return this.isFixturePlayed && this.isTeamWinner(team) ? { 'winner-team': true } : {};
  }

  public getSetWinnerClassObject(activity: ActivityInterface, team: string) {
    return this.isSetWinner(activity, team)
      ? {
          'set-winner': true
        }
      : {};
  }

  public getTeamActivityScore(points: number) {
    return Number.isInteger(points) ? points : '-';
  }

  get isFixturePlayed() {
    return isFixturePlayed(this.fixture);
  }

  get fixtureDate() {
    return this.fixture && dateFns.format(new Date(this.fixture.date), SCORE_MODAL_DATE_TIME_FORMAT);
  }

  get fixtureActivities() {
    const fixtureActivities = (this.fixture && this.fixture.activities) || [];

    if (fixtureActivities.length) {
      return sortBy(fixtureActivities, ['set']);
    }

    return [];
  }
}
